import { Alert, Container, Spinner } from "@sembark-travel/ui-base"
import { Breadcrumbs } from "@sembark-travel/ui-router"
import { Helmet } from "react-helmet-async"
import { useFetchIntegration } from "../../../../Integrations"
import { generatePath, useNavigate, useParams } from "../../../../router-utils"
import { EditWAQuickSendForm } from "../../../../WhatsAppQuickSends"

export default function WhatsAppIntegrationQuickSendEditPage() {
	const navigate = useNavigate()
	const { integrationId, quickSendId } = useParams(
		"/integrations/:integrationId/whatsapp/quick-sends/:quickSendId/edit"
	)
	const {
		data: integration,
		error: integrationError,
		isValidating: integrationLoading,
	} = useFetchIntegration(integrationId)

	if (!integration) {
		if (integrationLoading) {
			return <Spinner padding="8" alignCenter />
		}

		return (
			<Alert status="warning">
				{integrationError?.message ||
					"Unable to load the WhatsApp integration."}
			</Alert>
		)
	}

	const quickSendsPath = generatePath(
		"/integrations/:integrationId/whatsapp/quick-sends",
		{ integrationId }
	)
	const backToList = () =>
		navigate("/integrations/:integrationId/whatsapp/quick-sends", {
			params: { integrationId },
			replace: true,
		})

	return (
		<>
			<Helmet>
				<title>Edit Quick Send</title>
			</Helmet>
			<Breadcrumbs
				title="Edit Quick Send"
				items={[
					[generatePath("/org/integrations"), "Integrations"],
					[quickSendsPath, integration.name],
					["", "Edit Quick Send"],
				]}
			/>
			<Container paddingY="6" bgColor="default">
				<EditWAQuickSendForm
					quickSendId={quickSendId}
					onDone={backToList}
					onCancel={backToList}
				/>
			</Container>
		</>
	)
}
